import {Tile, TileProps} from "../components/Tile.tsx";
import {AgentPresence} from "../rpc/webrpc-client.gen.ts";
import {AgentCapsule} from "./capsule.tsx";
import {isEmpty} from "lodash";

export interface AgentPresenceTileProps extends Omit<TileProps, "Subject" | "color" | "variant"> {
    presence: AgentPresence;
}

export function AgentPresenceTile({presence, ...rest}: AgentPresenceTileProps) {
    let color: TileProps["color"] = "primary";
    let variant: TileProps["variant"] = "outlined";

    if (isEmpty(presence.outlets)) {
        color = "warning";
        variant = "soft";
    }

    if (presence.lastShiftEventFlavor === "BREAK_START") {
        color = "warning";
        variant = "soft";
    }

    if (presence.lastShiftEventFlavor === "SHIFT_END") {
        color = "neutral";
        variant = "soft";
    }

    return <Tile color={color} variant={variant} {...rest}
                 Subject={(props) =>
                     <AgentCapsule agent={presence.agent} {...props}/>}/>
}



